exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".preview{margin:20px 40px 0;background-image:url(" + require("../../../images/phone.png") + ");background-repeat:no-repeat;background-size:100%;padding:100px 16px;box-sizing:border-box;width:315px;height:700px;background-color:#fff}.preview .content{width:100%;height:100%;overflow-y:auto;overflow-x:hidden;background-color:#fff;word-break:break-all;white-space:nowrap;max-width:100%}.preview .content img{max-width:100%}.preview .content ::-webkit-scrollbar{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-155e9eb6","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/views/activity/components/preview.vue
// module id = 460
// module chunks = 0